export function isElement(node) {
  if (!node) return false;
  return node.nodeType === Node.ELEMENT_NODE;
}